const initialState = {
  allClients: [],
  clientUpdating: false,
  advisorConfig: null,
};

export default function app(state = initialState, action) {
  switch (action.type) {
    case "CLIENT_CREATE_SUCCESS":
      return {
        ...state,
        clientUpdating: false,
        allClients: [...state.allClients, action.payload.data],
      };
    case "GET_CLIENTS":
      return {
        ...state,
        allClients: action.payload.households,
      };
    case "LOAD_USER_APPLICATION_STATE_SUCCESS":
      return {
        ...state,
        allClients: action.payload.households,
      };
    case "CLIENT_CREATE_REQUESTED":
    case "CLIENTS_UPDATE_REQUESTED":
    case "GET_CLIENTS_REQUESTED":
      return {
        ...state,
        clientUpdating: true,
      };
    case "CLIENT_UPDATE_SUCCESS":
    case "GET_CLIENTS_SUCCESS":
      return {
        ...state,
        clientUpdating: false,
      };
    case "CLIENT_CREATE_FAIL":
    case "CLIENT_UPDATE_FAIL":
    case "GET_CLIENTS_FAIL":
      return {
        ...state,
        clientUpdating: false,
      };
    case "UPDATE_ADVISOR_CONFIG":
      return {
        ...state,
        advisorConfig: Object.assign({}, action.payload),
      };
    case "PORTFOLIO_FETCH_SUCCESS":
    case "PORTFOLIO_SAVE_SUCCESS":
      return {
        ...state,
        advisorConfig: action.payload.data.advisorConfig,
      };
    default:
      return { ...state };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client.reducer.js